<glxy-form-field>
  <glxy-label>{{ 'ASSOCIATIONS.MODAL.TITLE_TAGS' | translate }}</glxy-label>
  <extended>{{ 'ASSOCIATIONS.MODAL.DESCRIPTION_TAGS' | translate }}</extended>
  <glxy-tags-input
    [availableTags]="(filteredTags$ | async) ?? []"
    [uniqueTags]="true"
    [autocompleteOnly]="false"
    [formControl]="tagsControl"
    (searchText)="searchTextChanged.set($event)"
  />
</glxy-form-field>
